import { FC, useContext, useMemo } from 'react';

import { Badge } from 'antd';

import { RowSize, ColSize } from '../../../../../../../../../shared/components';
import { SectionQuotation } from '../../../../../shared';

import { StepThreeFormContext } from '../../contexts/StepThreeForm';
import { WizardDataFormContext } from '../../../../Wizard/contexts/WizardDataForm';

interface MultiplicativeFactorsSectionProps {
  componentId: string;
}

export const MultiplicativeFactorsSection: FC<
  MultiplicativeFactorsSectionProps
> = ({ componentId }) => {
  const { getMultiplicativeFactorsPerCoverageByVehicle } =
    useContext(StepThreeFormContext);
  const { coverageSelectedByVehicle } = useContext(WizardDataFormContext);

  const coverageSelected = useMemo(
    () =>
      coverageSelectedByVehicle.find((el) => el.componentId === componentId)
        ?.coverageSelected,
    [coverageSelectedByVehicle, componentId]
  );

  const multiplicativeFactors =
    useMemo(
      () =>
        getMultiplicativeFactorsPerCoverageByVehicle(
          componentId,
          coverageSelected?.codigo!
        ),
      [
        getMultiplicativeFactorsPerCoverageByVehicle,
        componentId,
        coverageSelected,
      ]
    ) ?? [];

  return (
    <SectionQuotation
      level='h3'
      title='Factores Multiplicativos'
      hasCard={false}
    >
      <RowSize rowProps={{ gutter: 0 }}>
        {multiplicativeFactors.length ? (
          multiplicativeFactors.map(({ descripcion, codigo }) => (
            <ColSize size={100} key={codigo}>
              <Badge color='black' text={descripcion} />
            </ColSize>
          ))
        ) : (
          <ColSize size={100}>
            <Badge
              color='black'
              text='No existen factores multiplicativos para este vehículo.'
            />
          </ColSize>
        )}
      </RowSize>
    </SectionQuotation>
  );
};
